import { StyledLoadingPlaceholder } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledTaskWrapper = styled.div`
  // modifying the close Icon for image modal
  span[class*='styles-module_close'] {
    opacity: 1 !important;
  }
`;

export const StyledLoadingWrapper = styled.div`
  min-height: 50vh;
`;

export const StyledLoadingRectangle = styled.div`
  ${StyledLoadingPlaceholder};
  animation-duration: 0.8s;
  border-radius: 0;
  display: block;
  min-height: 4.8rem;
  margin-bottom: 1.5rem;
  max-width: 100%;
  margin: auto auto 1rem;
`;
